export default {
    dateHelperChips: {
        toolbarAria: 'Pomoćnici za raspon datuma',
        applyDay: 'Primijeni dan',
        applyWeek: 'Primijeni tjedan (pon–ned)',
        applyWeekend: 'Primijeni vikend',
        applyMonth: 'Primijeni mjesec',
        applyQuarter: 'Primijeni kvartal',
        applyYear: 'Primijeni godinu',
    },
}
